<template>
  <section class="content">
    <div id="overlay" v-if="loading">
      <div class="spinner"></div>
      <br/>
      <h4>Loading...</h4>
    </div>
    <div class="box box-info">
      <form>
        <div class="p-fluid p-formgrid p-grid">
          <div class="p-field p-col-12 p-md-2">
            <label for="fromDate">From Date</label>
            <date-picker v-model="fromDate" valueType="format" v-if="!englishDateEnabled"/>
            <input-mask mask="9999-99-99" type="text" v-else class="nepali-calendar form-control" id="fromDate"
                        v-model="fromDate"/>
          </div>

          <div class="p-field p-col-12 p-md-2">
            <label for="toDate">To Date</label>
            <date-picker v-model="toDate" valueType="format" v-if="!englishDateEnabled"/>
            <input-mask mask="9999-99-99" type="text" class="nepali-calendar form-control" id="toDate"
                        v-model="toDate" v-else/>
          </div>

          <div class="p-field p-col-12 p-md-1 p-mt-5">
            <Button type="submit" @click.prevent="searchJournal" label="Search"
            class="p-button p-component addNewBtn btn-btm-0">
            </Button>
          </div>
          <div class="p-field p-col-12 p-md-1 p-mt-5">
            <Button type="submit" @click.prevent="reset"
                    class="p-button-raised" label="Reset">
            </Button>
          </div>

          <div class="p-field p-col-12 p-md-1 p-mt-5">
          <a href="#" @click.prevent="exportCSV()">
          <img src="../../../../static/img/excel.png" style="float:right;height: 3em;width: 3em;"/>
          </a>
          </div>

        </div>
      </form>
      <div class="p-fluid p-formgrid p-grid">
        <div class="p-field p-col-12 p-col-12">
         
          <DataTable :value="debitNoteBookLists"
                     :paginator="true" ref="po"
                     :rowsPerPageOptions="[100,500,1000]"
                     :rows="100" :filters="filters"
                     class="p-datatable-responsive p-datatable-gridlines"
                     data-key="id">
            <Column header="S.N">
              <template #body="sl">
                {{ sl.index + 1 }}
              </template>
            </Column>
            <Column
              header="Miti" :sortable="true"
              field="transactionDateNepali" filterMatchMode="contains">
              <template #body="slotProps">
                {{ !slotProps.data.repatedTransaction ? slotProps.data.transactionDateNepali : '' }}
              </template>
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['transactionDateNepali']"/>
              </template>
            </Column>
            <Column header="Date" :sortable="true" field="transactionDate" filterMatchMode="contains">
              <template #body="slotProps">
                {{ !slotProps.data.repatedTransaction ? slotProps.data.transactionDate : '' }}
              </template>
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['transactionDate']"/>
              </template>
            </Column>
            <Column header="Vou Type" :sortable="true" field="entryType" filterMatchMode="contains">
              <template #body="slotProps">
                {{ !slotProps.data.repatedTransaction ? slotProps.data.entryType : '' }}
              </template>
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['entryType']"/>
              </template>
            </Column>
            <Column header="Voucher" :sortable="true" field="voucher" filterMatchMode="contains">
              <template #body="slotProps">
                {{ !slotProps.data.repatedTransaction ? slotProps.data.voucher : '' }}
              </template>
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['voucher']"/>
              </template>
            </Column>
            <Column header="Account" :sortable="true" field="accountName" filterMatchMode="contains">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['accountName']"/>
              </template>
            </Column>
            <Column header="Narration" field="remarks">
              <template #body="slotProps">
                {{ !slotProps.data.repatedTransaction ? slotProps.data.remarks : '' }}
              </template>
              <!-- <template #filter>
                 <InputText type="text" class="p-column-filter" v-model="filters['remarks']" />
             </template> -->
            </Column>
            <Column header="Debit" field="debitBalance"
                    filterMatchMode="contains" bodyStyle="color:#00a65a;text-align: right">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['debitBalance']"/>
              </template>
            </Column>
            <Column header="Credit" field="creditBalance"
                    filterMatchMode="contains"
                    bodyStyle="color:#dd4b39;text-align: right">
              <template #filter>
                <InputText type="text" class="p-column-filter" v-model="filters['creditBalance']"/>
              </template>
            </Column>
            <!-- <Column header="closing Balance" field="closingBalance" filterField="closingBalance" filterMatchMode="contains" /> -->
            <template #empty>No record found</template>
            <Column header="Action">
              <template #body="slotProps">
                <!-- Edit Button -->
                <Button class="p-button-raised  p-button-success"
                        v-if="renderIf(slotProps.data) && !slotProps.data.repatedTransaction"
                        @click="editJournalBook(slotProps.data)" disabled>
                  <i class="fa fa-edit"/>
                </Button>
                <Button class="p-button-raised  p-button-success"
                        v-if="!renderIf(slotProps.data) && !slotProps.data.repatedTransaction"
                        @click="editJournalBook(slotProps.data)"/>

                <!-- Delete Button -->
                <Button class="p-button-raised  p-button-danger"
                        v-if="!renderIf(slotProps.data) && !slotProps.data.repatedTransaction "
                        @click="openDialog(slotProps.data)"/>
                <Button class="p-button-raised p-button-danger"
                        v-else-if="renderIf(slotProps.data) && !slotProps.data.repatedTransaction"
                        @click="openDialog(slotProps.data)" disabled/>

              </template>
            </Column>
          </DataTable>
        </div>
        <Dialog v-model="dialogShow" @cancel="cancel" @deleted="deleteJournal"/>
      </div>
    </div>
  </section>
</template>
<script>
import Dropdown from 'primevue/dropdown'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import DatePicker from 'vue2-datepicker'
import $ from 'jquery'
import globalKey from '../../../store/globalKey'
import axios from 'axios'
import InputText from 'primevue/inputtext'
import Dialog from '../../layout/dialog'
import InputMask from 'primevue/inputmask'
import Button from 'primevue/button'

export default {
  name: 'debitNote',
  data() {
    return {
      name: '',
      fromDate: null,
      toDate: null,
      account: '',
      accountMasterId: 0,
      loading: false,
      columnList: '',
      filters: {},
      type: 'debNote',
      dialogShow: false,
      // journalId: null,
      tranId: null,
      tranModuleType: null,
      englishDateEnabled: true
    }
  },
  computed: {
    accountMasterList() {
      return this.$store.state.accounting.accountList
    },
    debitNoteBookLists() {
      return this.$store.state.accountingReport.debitNoteBookLists
    }
  },
  mounted() {
    this.accountList()
    this.checkEnglish()
    if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
      this.nepaliDate()
    }
    if (!this.$store.getters.englishDate && this.salesChallan === undefined ||
      this.$store.state.isEnglishDateEnabled === 'false') {
      this.setNepaliDate()
    }
    if (this.$store.state.isEnglishDateEnabled && this.$store.state.isEnglishDateEnabled !== 'false') {
      this.setEnglishDate()
    }
    this.columnNames()
  },
  methods: {
    async searchJournal() {
      if (this.account === '') {
        this.accountMasterId = 0
      } else {
        this.accountMasterId = this.account.id
      }
      let journal = {
        fromDate: this.fromDate,
        toDate: this.toDate,
        accountMasterId: this.accountMasterId,
        type: this.type
      }
      this.loading = true
      await this.$store.dispatch('loadDebitNoteBookList', journal)
      this.loading = false
    },
    async accountList() {
      await this.$store.dispatch('accountMasterList')
    },
    editJournalBook(data) {
      let journalEdit = {
        tranId: data.tranId,
        tranModuleType: data.tranModuleType
      }
      if (data.entryType === 'debNote') {
        this.$router.push({name: 'Debit Note Entry', params: {debitNote: journalEdit}})
      }
    },
    renderIf(data) {
      if (data.entryType === 'purInvoice' || data.entryType === 'purOrder' || data.entryType === 'purChallan' || data.entryType === 'salesInvoice' || data.entryType === 'salesOrder' || data.entryType === 'salesChallan' || data.entryType === 'purReturn' || data.entryType === 'salesReturn') {
        return true
      }
    },
    exportCSV() {
      let data = {
        fromDate: this.fromDate,
        toDate: this.toDate,
        columnList: this.columnList,
        accountMasterId: this.accountMasterId,
        type: this.type
      }
      axios({
        url: globalKey + '/fileDownload/excelReportAccounting/' + this.$store.getters.organisationId + '/' + this.$store.getters.userId + '/' + data.fromDate + '/' + data.toDate + '/journalBook' + '/' + this.$store.getters.fyId + '/' + data.columnList + '/' + data.accountMasterId + '/' + data.type,
        method: 'get',
        headers: {'Accept': 'application/vnd.ms-excel', 'Authorization': localStorage.token},
        responseType: 'blob'
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]), {type: response.data.type})
        const link = document.createElement('a')
        const contentDisposition = response.headers['content-disposition']
        let fileName = 'journalBook.xlsx'
        if (contentDisposition) {
          const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
          if (fileNameMatch.length === 2) {
            fileName = fileNameMatch[1]
          }
        }
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()
        link.remove()
        window.URL.revokeObjectURL(url)
      })
    },
    columnNames() {
      for (let i = 0; i < this.$refs.po.columns.length; i++) {
        this.columnList += this.$refs.po.columns[i].header + ','
      }
    },
    reset() {
      // this.debitNoteBookLists = []
      this.account = ''
      if (!this.$store.getters.englishDate || this.$store.state.isEnglishDateEnabled === 'false') {
        this.fromDate = this.$store.getters.nepaliNewDate
        this.toDate = this.$store.getters.nepaliNewDate
      } else {
        this.fromDate = new Date().toISOString().slice(0, 10)
        this.toDate = new Date().toISOString().slice(0, 10)
      }
    },
    setNepaliDate() {
      if (this.$store.getters.nepaliNewDate !== '') {
        this.fromDate = this.$store.getters.nepaliNewDate
        this.toDate = this.$store.getters.nepaliNewDate
      }
    },
    async deleteJournal(deleteReason) {
      if (deleteReason.trim() === '') {
        this.$toast.add({severity: 'error', summary: '', detail: 'Delete Reason cannot be empty!', life: 10000})
        this.dialogShow = true
        return
      }
      let deleteRea = {
        // journalId: this.journalId,
        deleteReason: deleteReason,
        tranId: this.tranId,
        tranModuleType: this.tranModuleType
      }
      let resp = await this.$store.dispatch('deleteJournal', deleteRea)
      if (resp.data.status === 'ERROR') {
        this.$toast.add({severity: 'error', summary: '', detail: resp.data.message, life: 10000})
      } else {
        this.$toast.add({severity: 'success', summary: '', detail: resp.data.message, life: 10000})
      }
      this.closeDialog()
    },
    openDialog(data) {
      this.dialogShow = true
      this.journalId = data.id
      this.tranId = data.tranId
      this.tranModuleType = data.tranModuleType
    },
    closeDialog() {
      this.dialogShow = false
    },
    cancel(data) {
      this.dialogShow = false
    },
    setEnglishDate() {
      this.fromDate = new Date().toISOString().slice(0, 10)
      this.toDate = new Date().toISOString().slice(0, 10)
    },
    checkEnglish() {
      if (this.$store.state.isEnglishDateEnabled === false || this.$store.state.isEnglishDateEnabled === 'false') {
        this.englishDateEnabled = true
        return
      } else {
        this.englishDateEnabled = false
        return
      }
    },
    nepaliDate() {
      $('#fromDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.fromDate = $('#fromDate').val()
        }
      })
      $('#toDate').nepaliDatePicker({
        ndpYear: true,
        ndpMonth: true,
        ndpYearCount: 10,
        disableBefore: this.$store.state.startDate,
        disableAfter: this.$store.state.endDate,
        onChange: () => {
          this.toDate = $('#toDate').val()
        }
      })
    }
  },
  components: {
    Dropdown,
    DatePicker,
    Column,
    DataTable,
    InputText,
    Dialog,
    InputMask,
    Button
  }
}
</script>
<style scoped src="@../../../static/css/purchase.css">

</style>



// WEBPACK FOOTER //
// debitNoteRegister.vue?a8a14f12